export type FeesAccordionCopy = {
  fullServiceIntro: string;
  fullServiceItems: string[];
  securePayIntro: string;
  securePayItems: string[];
};

export const FEES_ACCORDION_COPY: Record<'eligible' | 'ineligible', FeesAccordionCopy> = {
  eligible: {
    fullServiceIntro:
      'We facilitate everything, so you can skip the DMV and checkout from the comfort of your home. This includes:',
    fullServiceItems: [
      'Based on location, we provide a temporary permit or plate transfer instructions, allowing you to drive the vehicle home once the purchase is finalized',
      'Registering your new vehicle at the DMV in your name',
      "Verifying the seller's title, transferring the title, and mailing a new title to you (or your lender)",
      'Mailing new license plates to your home',
      'Secure payment with cash, financing online, or financing with your own bank',
      'Online credit application and financing decisions for buyers who need a loan',
      'Facilitating other paperwork',
      'Live customer support to help answer any questions or address outstanding tasks',
    ],
    securePayIntro: 'We facilitate the money transfer only, including:',
    securePayItems: [
      'Secure payment with cash (ACH, wire transfer, or credit/debit card), financing online, or financing with your own bank',
      "Payment released to the seller after you've officially taken possession of the vehicle",
    ],
  },
  ineligible: {
    fullServiceIntro: 'We facilitate almost everything, including:',
    fullServiceItems: [
      'Secure payment with cash (ACH, wire transfer, or credit/debit card), financing online, or financing with your own bank',
      'Online credit application and financing decisions if you need a loan',
      "Payment released to the seller after you've officially taken possession of the vehicle",
      "Verifying the seller's title",
      'Facilitating paperwork so you have what you need at the DMV',
      'Based on location, we will provide a temporary permit or plate transfer instructions allowing you to drive the vehicle home once the purchase is finalized',
      'Live customer support to guide you through the process',
    ],
    securePayIntro: 'We facilitate the money transfer only, including:',
    securePayItems: [
      'Secure payment with cash (ACH, wire transfer, or credit/debit card), financing online, or financing with your own bank',
      "Payment released to the seller after you've officially taken possession of the vehicle",
    ],
  },
};
